import axios from "axios";
/* {
  // baseURL: 'URL/api'
  baseURL: window.httpURL
} */
const axiosInstance = axios.create();
var token = ''
axiosInstance.interceptors.request.use(
  async function (config) {
    token = await localStorage.getItem("wtokenid");
    if (token) {
      config.headers["tokenid"] = token;
      //   config.headers["Authorization"] = 'Bearer ' + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosInstance;
